<template>
  <div>
    <el-container>
      <el-main>
        <div class="mx-auto">
          <h3>直接建立商品</h3>
        </div>
        <el-form ref="form" :rules="rules" :model="form" label-width="80px">
          <el-form-item label="經銷商">
            <selectCompany :id.sync="form.company_id" />
          </el-form-item>
          <el-form-item label="品號" prop="ProductNo">
            <el-input v-model="form.ProductNo" />
          </el-form-item>
          <el-form-item label="品名" prop="ProductNa">
            <el-input v-model="form.ProductNa" />
          </el-form-item>
          <el-form-item label="單價" prop="UnitPrice">
            <el-input v-model.number="form.UnitPrice" />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit('form')">立即建立</el-button>
            <el-button>取消</el-button>
          </el-form-item>
        </el-form>
        <hr />
        <div class="mx-auto">
          <h3 class="text-center">或是利用EXCEL文件上傳</h3>
          <upload-excel :upload-action="upload" />

          <a href="./商品資料範例.csv">
            <el-button type="success">下載範例檔案 </el-button>
          </a>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import { createProduct, importProducts } from '@/api/product';
import selectCompany from '@/components/select/companies';
import uploadExcel from '@/components/UploadExcel/index.vue';
const methods = {
  async onSubmit(formName) {
    this.$refs[formName].validate(async (valid) => {
      if (valid) {
        await this.createProduct();
        this.$refs[formName].resetFields();
      } else {
        return false;
      }
    });
  },
  async upload(file) {
    const formData = new FormData();
    formData.append('file', file.file);
    formData.append('company_id', this.form.company_id);
    const data = await importProducts(formData);
    if (data === 'Success') {
      this.$message({
        message: '建立成功',
        type: 'success',
      });
    }
  },
  async createProduct() {
    const data = await createProduct(this.form);
    if (data) {
      this.$message({
        message: '建立成功',
        type: 'success',
      });
    }
  },
};
export default {
  components: { uploadExcel, selectCompany },
  data() {
    return {
      form: {
        ProductNa: '',
        ProductNo: '',
        UnitPrice: '',
        VendorNo: 1,
        ChannelType: 1,
        PackType: 1,
        company_id: 1,
      },
      rules: {
        ProductNa: [{ required: true, message: '必填', trigger: 'blur' }],
        ProductNo: [{ required: true, message: '必填', trigger: 'blur' }],
        UnitPrice: [
          { required: true, message: '必填', trigger: 'blur' },
          { type: 'integer', message: '必須為數字', trigger: 'blur' },
        ],
      },
    };
  },
  created() {},
  methods,
};
</script>
<style>
.mx-auto {
  margin: 0 auto;
  text-align: center;
}
</style>
